<template>
  <div v-rect-loading="loading" class="questionnaire-list">
    <TableList
      defaultExpandAll
      rowKey="_vid"
      :listData="listData"
      :tableColumns="tableColumns"
      :actionBtn="actionBtn"
      @create="handleCreate"
    >
      <template #stepIcon="{ row }">
        <i v-if="row._vType === QUESTIONNAIRE_TYPE.STEP" class="step-icon" :class="row.icon"></i>
      </template>
      <template #status="{ row, data }">
        <el-switch v-if="row._vType === QUESTIONNAIRE_TYPE.QUESTIONNAIRE" :value="data" @change="handleEnabledChange($event, row)"></el-switch>
      </template>
    </TableList>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
import TableList from '@/components/tableList/allowDragSortTable.vue'

const QUESTIONNAIRE_TYPE = {
  QUESTIONNAIRE: 'questionnaire',
  STEP: 'step'
}

export default {
  components: {
    TableList
  },
  data () {
    return {
      loading: false,
      i18nPrefix: 'admin.company.jobApplication',
      QUESTIONNAIRE_TYPE,
      listData: []
    }
  },
  computed: {
    previewLocale () {
      return this.$parent.activePreviewLocale
    },
    actionBtn () {
      return {
        edit: {
          show: (rowData) => rowData._vType === QUESTIONNAIRE_TYPE.QUESTIONNAIRE,
          onclick: this.handleEdit
        }
      }
    },
    tableColumns () {
      const columns = [
        {
          label: this.$t(`${this.i18nPrefix}.label.questionnaireName`),
          dataKey: 'name'
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.questionnaireStatus`),
          dataKey: 'status',
          slotName: 'status',
          formatter: (data, row) => {
            if (row._vType === QUESTIONNAIRE_TYPE.QUESTIONNAIRE) {
              return data
            }
          }
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.stepIcon`),
          dataKey: 'icon',
          slotName: 'stepIcon'
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.stepName`),
          dataKey: 'title',
          formatter: (data, row) => {
            return row[`title_${this.previewLocale}`]
          }
        }
      ]
      return columns
    }
  },
  created () {
    this.fetchListData()
  },
  methods: {
    ...mapActions('jobApplicationManagement', [
      'searchQuestionnaire',
      'updateQuestionnaire'
    ]),
    async fetchListData () {
      this.loading = true
      try {
        const resp = await this.searchQuestionnaire()
        if (resp && resp.questionnaires) {
          const questionnaireType = QUESTIONNAIRE_TYPE.QUESTIONNAIRE
          const stepType = QUESTIONNAIRE_TYPE.STEP
          this.listData = _.chain(resp.questionnaires)
            .map(item => {
              const dataItem = {
                ...item,
                _vid: `${questionnaireType}_${item.id}`,
                _vType: questionnaireType,
                status: item.status === 1,
                children: []
              }
              if (dataItem.steps && dataItem.steps.length > 0) {
                dataItem.children = _.map(dataItem.steps, step => {
                  return {
                    ...step,
                    _vid: `${questionnaireType}_${item.id}_${stepType}_${step.id}`,
                    _vType: stepType
                  }
                })
              }
              delete dataItem.steps
              return dataItem
            })
            .orderBy(['status'], ['desc'])
            .value()
        }
      } finally {
        this.loading = false
      }
    },
    handleCreate () {
      this.$router.push('/v-admin/job-application-management/questionnaire/add')
    },
    handleEdit (rowData) {
      this.$router.push(`/v-admin/job-application-management/questionnaire/edit/${rowData.id}`)
    },
    async handleEnabledChange (status, rowData) {
      this.loading = true
      try {
        const statusData = {
          id: rowData.id,
          change_status: status
        }
        const resp = await this.updateQuestionnaire(statusData)
        if (resp) {
          rowData.status = statusData.change_status
          this.$message.success(this.$t('common.message.optionSuccess'))
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.questionnaire-list {
  .step-icon {
    font-size: 32px;
  }

  .status-icon {
    display: inline-block;
    width: 15px;
    height: 15px;
    background: url($baseDomain + 'static/images_en/img_grey.png') no-repeat;
    vertical-align: middle;

    &.is-active {
      background: url($baseDomain + 'static/images_en/img_green.png') no-repeat;
    }
  }
}
</style>
